<div class="mtr-modal-backdrop" *ngIf="isVisible()" (click)="onBackdropClick()">
  <div
    class="mtr-modal-container"
    [class.shake]="isShaking()"
    role="dialog"
    aria-modal="true"
    aria-labelledby="mtr-link-title"
    (click)="$event.stopPropagation()"
  >
    <!-- Top Step Progress Tracker -->
    <div class="step-progress-row">
      <div class="step-pill" [class.active]="currentStep() === 'otp'" [class.complete]="currentStep() === 'password'">
        <span class="step-dot" *ngIf="currentStep() !== 'password'">1</span>
        <svg *ngIf="currentStep() === 'password'" class="step-check-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
          <polyline points="20 6 9 17 4 12" />
        </svg>
        <span class="step-text">Email OTP</span>
      </div>
      <div class="step-divider" [class.complete]="currentStep() === 'password'"></div>
      <div class="step-pill" [class.active]="currentStep() === 'password'">
        <span class="step-dot">2</span>
        <span class="step-text">Password</span>
      </div>
    </div>

    <!-- Top Brand / Icon Badge -->
    <div class="modal-badge-wrapper">
      <div class="modal-badge-glow"></div>
      <div class="modal-badge-icon">
        <!-- Shield / Mail icon for Step 1 -->
        <svg *ngIf="currentStep() === 'otp'" class="svg-badge" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          <path d="M9 12l2 2 4-4"/>
        </svg>
        <!-- Key / Link icon for Step 2 -->
        <svg *ngIf="currentStep() === 'password'" class="svg-badge" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
        </svg>
      </div>
    </div>

    <!-- Header & Message -->
    <div class="modal-header">
      <h2 id="mtr-link-title" class="modal-title">
        {{ currentStep() === 'otp' ? 'Existing MatchTrader Account Found' : 'Link Weko Trade Account' }}
      </h2>
      <p class="modal-message">
        {{ currentStep() === 'otp' 
            ? 'A MatchTrader account is registered with your email. A 6-digit verification code has been sent to your registered email address.' 
            : 'Email verified. Enter your Weko account password to link your trading account.' 
        }}
      </p>
    </div>

    <!-- User Account Email Identifier (if available) -->
    <div class="account-identifier" *ngIf="userEmail()">
      <span class="account-pill">
        <svg class="pill-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
        <span class="pill-email">{{ userEmail() }}</span>
      </span>
    </div>

    <!-- STEP 1: OTP VERIFICATION FORM -->
    <div class="step-content" *ngIf="currentStep() === 'otp'">
      <form (ngSubmit)="submitOtp()" class="modal-form" autocomplete="off">
        <div class="form-field-group">
          <label class="field-label text-center">Enter 6-Digit Verification Code</label>
          
          <div class="otp-inputs-grid" (paste)="onOtpPaste($event)">
            <input
              *ngFor="let i of otpIndices; trackBy: trackByIndex"
              #otpInput
              [id]="'mtr-otp-' + i"
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="1"
              class="otp-digit-box"
              [class.has-value]="otpDigits[i]"
              [class.input-error]="otpError()"
              [disabled]="isVerifyingOtp() || isSendingOtp()"
              [attr.aria-label]="'Verification code digit ' + (i + 1)"
              [value]="otpDigits[i]"
              (input)="onOtpInput($event, i)"
              (keydown)="onOtpKeyDown($event, i)"
              autocomplete="one-time-code"
            />
          </div>

          <!-- OTP Field Error Message -->
          <div class="field-error-message center-error" *ngIf="otpError()">
            <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            <span>{{ otpError() }}</span>
          </div>
        </div>

        <!-- Resend OTP Row -->
        <div class="resend-row">
          <span class="resend-label">Didn't receive code?</span>
          <ng-container *ngIf="resendCooldown() > 0">
            <span class="resend-cooldown">Resend in {{ resendCooldown() }}s</span>
          </ng-container>
          <ng-container *ngIf="resendCooldown() === 0">
            <button
              type="button"
              class="btn-resend"
              (click)="resendOtp()"
              [disabled]="isSendingOtp()"
            >
              <span *ngIf="!isSendingOtp()">Resend Code</span>
              <span *ngIf="isSendingOtp()">Sending code...</span>
            </button>
          </ng-container>
        </div>

        <!-- Verify OTP Action Button -->
        <div class="action-row">
          <button
            type="submit"
            class="btn-link-account"
            [disabled]="isVerifyingOtp() || !isOtpComplete"
          >
            <span class="btn-spinner" *ngIf="isVerifyingOtp()"></span>
            <span *ngIf="!isVerifyingOtp()">Verify Code</span>
            <span *ngIf="isVerifyingOtp()">Verifying Code...</span>
          </button>
        </div>

        <!-- Secondary Escape Action -->
        <div class="footer-actions">
          <button type="button" class="btn-logout" (click)="onLogout()">
            Log out / Switch account
          </button>
        </div>
      </form>
    </div>

    <!-- STEP 2: PASSWORD FORM -->
    <div class="step-content" *ngIf="currentStep() === 'password'">
      <form (ngSubmit)="submitPassword()" class="modal-form" autocomplete="off">
        <div class="form-field-group">
          <label for="mtr-weko-password" class="field-label">Weko Password</label>
          
          <div class="input-shell" [class.input-error]="passwordError()">
            <div class="input-prefix-icon">
              <svg class="key-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>

            <input
              id="mtr-weko-password"
              [type]="showPassword() ? 'text' : 'password'"
              [(ngModel)]="password"
              name="password"
              placeholder="Enter your Weko password"
              autocomplete="current-password"
              class="password-input"
              [disabled]="isSubmitting()"
              (input)="onInput()"
              required
            />

            <button
              type="button"
              class="password-toggle-btn"
              (click)="togglePassword()"
              [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
              tabindex="-1"
            >
              <svg *ngIf="!showPassword()" class="toggle-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
              <svg *ngIf="showPassword()" class="toggle-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                <line x1="1" y1="1" x2="23" y2="23"/>
              </svg>
            </button>
          </div>

          <!-- Password Error Message directly under input -->
          <div class="field-error-message" *ngIf="passwordError()">
            <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            <span>{{ passwordError() }}</span>
          </div>
        </div>

        <!-- Helper link -->
        <div class="helper-row">
          <button type="button" class="btn-step-back" (click)="goToStep('otp')">
            ← Change code / Re-verify
          </button>
          <a (click)="onForgotPassword($event)" class="forgot-password-link" role="button" tabindex="0">
            Forgot Password?
          </a>
        </div>

        <!-- Link Account Action Button -->
        <div class="action-row">
          <button
            type="submit"
            class="btn-link-account"
            [disabled]="isSubmitting() || !password.trim()"
          >
            <span class="btn-spinner" *ngIf="isSubmitting()"></span>
            <span *ngIf="!isSubmitting()">Link Account</span>
            <span *ngIf="isSubmitting()">Linking Account...</span>
          </button>
        </div>

        <!-- Secondary Escape Action -->
        <div class="footer-actions">
          <button type="button" class="btn-logout" (click)="onLogout()">
            Log out / Switch account
          </button>
        </div>
      </form>
    </div>

  </div>
</div>
